<po-page-default p-title="Processamento Faturas" [p-breadcrumb]="breadcrumb"
  p-subtitle="Importe arquivos ZIP para processar faturas automaticamente.">

  <!-- Resumo da página -->
  <div class="page-summary">
    <div class="page-summary-icon">
      <i class="an an-file-arrow-up"></i>
    </div>
    <div class="page-summary-text">
      <p class="po-font-subtitle po-mb-0">Importação e Processamento de Faturas</p>
      <p class="page-summary-hint">Envie arquivos <b>.zip</b> para processamento. O resultado será baixado automaticamente em formato Excel.</p>
    </div>
  </div>

  <po-divider></po-divider>

  <!-- Seção: Instruções -->
  <div class="pf-section po-mt-3">
    <div class="pf-section-header">
      <i class="an an-info"></i>
      <span>Instruções</span>
    </div>
    <div class="pf-section-body">
      <div class="pf-rules">
        <div class="pf-rule">
          <i class="an an-check-circle"></i>
          <span>O arquivo deve estar no formato <b>.ZIP</b>.</span>
        </div>
        <div class="pf-rule">
          <i class="an an-check-circle"></i>
          <span>Múltiplos arquivos podem ser enviados simultaneamente.</span>
        </div>
        <div class="pf-rule">
          <i class="an an-check-circle"></i>
          <span>Limite de tamanho: até <b>30 MB</b> por arquivo.</span>
        </div>
        <div class="pf-rule">
          <i class="an an-check-circle"></i>
          <span>Após o processamento, o resultado será baixado automaticamente como planilha Excel.</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Seção: Upload -->
  <div class="pf-section po-mt-3">
    <div class="pf-section-header">
      <i class="an an-upload-simple"></i>
      <span>Envio de Arquivos</span>
    </div>
    <div class="pf-section-body">
      <po-upload #upload [p-restrictions]="restrictions" p-size="medium" [p-drag-drop]="true"
        [p-multiple]="true" [p-drag-drop-height]="150" [p-url]="urlPlaceholder" [p-hide-send-button]="true">
      </po-upload>

      <div class="pf-action-row po-mt-3">
        <po-button p-icon="an an-paper-plane-tilt" p-label="Processar Arquivos" [p-disabled]="loading"
          [p-loading]="loading" (p-click)="sendArquivos()">
        </po-button>
      </div>
    </div>
  </div>

</po-page-default>
